import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getFormValues, isDirty, isValid, reset, change } from 'redux-form';
import { actions as documentOutputActions, selectors as documentOutputSelectors } from 'ducks/documentOutput';
import PrintTransmitPODialog from './PrintTransmitPODialog';
import { IApplicationState } from 'ducks/reducers';

const FORM_NAME = 'PrintTransmitPOForm';

const mapStateToProps = (state: IApplicationState) => ({
  purchaseOrderOuputOptions: documentOutputSelectors.options('PO', 'PrintPurchaseOrderOutput')(state),
  dirty: isDirty(FORM_NAME)(state),
  values: getFormValues(FORM_NAME)(state),
  isValid: isValid(FORM_NAME)(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    resetForm: () => reset(FORM_NAME),
    changeFormFieldValue: (fieldName: string, fieldValue: any) => change(FORM_NAME, fieldName, fieldValue),
    clearPurchaseOrderOuputOptions: () => documentOutputActions.clearInitialOptions('PO', 'PrintPurchaseOrderOutput'),
    setPurchaseOrderOuputOptions: (options) => documentOutputActions.updateInitialOptions('PO', 'PrintPurchaseOrderOutput', options)
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PrintTransmitPODialog);
